import React from 'react';
import Icon from '../../../components/AppIcon';

const AboutSection = () => {
  const stats = [
    { icon: 'UserCheck', label: 'Assign Chores', desc: 'To the right child with clear expectations', color: '#0f1f3d', textColor: '#fff', accentColor: '#2dd4bf' },
    { icon: 'Clock', label: 'Set Deadlines', desc: 'With expected completion times', color: '#2dd4bf', textColor: '#0f1f3d', accentColor: '#0f1f3d' },
    { icon: 'BarChart2', label: 'Review Progress', desc: "See what's done and what's pending", color: '#ff6b6b', textColor: '#fff', accentColor: '#fff' },
    { icon: 'Camera', label: 'Require Proof', desc: 'Photo verification before approval', color: '#f59e0b', textColor: '#0f1f3d', accentColor: '#0f1f3d' },
  ];

  return (
    <section className="py-24 relative overflow-hidden" style={{background: '#f8f7f4'}}>
      {/* Decorative accent */}
      <div className="absolute top-0 left-0 w-2 h-full" style={{background: 'linear-gradient(180deg, #2dd4bf, #ff6b6b, #f59e0b)'}}></div>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          
          {/* Left: text */}
          <div>
            <div className="inline-flex items-center gap-2 mb-6 px-4 py-2 rounded-full text-sm font-bold uppercase tracking-widest" style={{background: '#2dd4bf20', color: '#0d9488', border: '1px solid #2dd4bf40'}}>
              <Icon name="Info" size={14} />
              About Cynizee
            </div>
            <h2 className="font-heading font-bold leading-tight mb-6" style={{fontSize: 'clamp(2rem, 4vw, 3rem)', color: '#0f1f3d'}}>
              Built for real families.{' '}
              <span style={{color: '#ff6b6b'}}>Designed for lasting change.</span>
            </h2>
            <p className="text-lg leading-relaxed mb-6" style={{color: '#64748b'}}>
              Cynizee is a smart family chore and accountability app built to help parents stay organized and help kids build better habits.
            </p>
            <p className="text-lg leading-relaxed mb-10" style={{color: '#64748b'}}>
              Parents can assign chores, set deadlines, review progress, require proof, and keep children motivated with a system that makes expectations clear and follow-through easier. Instead of repeating the same reminders every day, Cynizee gives families a structured way to manage responsibilities in one place.
            </p>

            {/* Highlight quote */}
            <div className="rounded-2xl p-6 border-l-4" style={{background: '#0f1f3d', borderLeftColor: '#2dd4bf'}}>
              <p className="font-heading font-semibold text-lg leading-snug" style={{color: '#fff'}}>
                "One app. Every chore. Zero excuses."
              </p>
              <p className="text-sm mt-2" style={{color: 'rgba(255,255,255,0.5)'}}>The Cynizee promise to every family</p>
            </div>
          </div>

          {/* Right: stat cards */}
          <div className="grid grid-cols-2 gap-4">
            {stats?.map((item, i) => (
              <div
                key={i}
                className="rounded-2xl p-6 flex flex-col gap-3 transition-transform duration-300 hover:-translate-y-1 hover:shadow-xl cursor-default"
                style={{background: item?.color}}
              >
                <div className="w-11 h-11 rounded-xl flex items-center justify-center" style={{background: `${item?.accentColor}25`}}>
                  <Icon name={item?.icon} size={22} style={{color: item?.accentColor}} />
                </div>
                <div>
                  <h3 className="font-heading font-bold text-base mb-1" style={{color: item?.textColor}}>{item?.label}</h3>
                  <p className="text-sm leading-snug" style={{color: `${item?.textColor}99`}}>{item?.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
